<script setup lang="ts">
import { useLoginStore } from "@/stores/login";
import { onMounted } from "vue";

const loginStore = useLoginStore();

onMounted(() => {
    loginStore.updateLoginState();
});

</script>

<template>
    <div class="mobile-nav">
        <a
            href="tel:08003265479"
        >
            <img
                src="../../assets/images/telephone.svg"
                alt="Call us"
            >
            <span class="visually-hidden">Telephone</span>
        </a>
        <a
            href="mailto:hello@annuityready.com"
        >
            <img
                src="../../assets/images/email.svg"
                alt="Email us"
            >
            <span class="visually-hidden">Email</span>
        </a>
        <router-link
            v-if="loginStore.isLoggedIn"
            id="header-logout"
            class="login"
            to="/logout"
        >
            <img
                src="../../assets/images/login.svg"
                alt="Logout"
            >
            Logout
        </router-link>
        <router-link
            v-else
            id="header-login"
            class="login"
            to="/login"
        >
            <img
                src="../../assets/images/login.svg"
                alt="send application image"
            >
            Login
        </router-link>
    </div>
</template>
